import { render, staticRenderFns } from "./staffFeeManageList.vue?vue&type=template&id=24b8b524&scoped=true"
import script from "./staffFeeManageList.vue?vue&type=script&lang=js"
export * from "./staffFeeManageList.vue?vue&type=script&lang=js"
import style0 from "./staffFeeManageList.vue?vue&type=style&index=0&id=24b8b524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b8b524",
  null
  
)

export default component.exports